module.exports = __webpack_public_path__ + "img/icon-shield-white.bd14d779.svg";